import { BaseContainerModel } from '../../base-container.model';
import { bl_fi_comp_label_link_RowClass } from '../../../dbschema/bl_fi_comp_label_link.model';

export class CompanyLabelLinkContainerModel extends BaseContainerModel {
  bl_fi_comp_label_link: bl_fi_comp_label_link_RowClass = new bl_fi_comp_label_link_RowClass();
}